import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Crown, Construction, Bell } from 'lucide-react';

interface ComingSoonFeatureProps {
  title: string;
  description: string;
  isEnterprise?: boolean;
  estimatedRelease?: string;
}

export const ComingSoonFeature = ({ 
  title, 
  description, 
  isEnterprise = false,
  estimatedRelease = "Q2 2024"
}: ComingSoonFeatureProps) => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <h3 className="text-2xl font-bold">{title}</h3>
            {isEnterprise && (
              <Badge variant="secondary" className="text-xs">
                <Crown className="h-3 w-3 mr-1" />
                Enterprise
              </Badge>
            )}
          </div>
          <p className="text-muted-foreground">{description}</p>
        </div>
      </div>

      <Card className="border-dashed">
        <CardContent className="flex flex-col items-center justify-center min-h-[400px] py-12">
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-6">
            <Construction className="h-8 w-8 text-primary" />
          </div>
          
          <h4 className="text-xl font-semibold mb-2">Coming Soon</h4>
          <p className="text-muted-foreground text-center max-w-md mb-6">
            We're working hard to bring you this feature. It will include advanced collaboration tools, 
            real-time messaging, and task management capabilities.
          </p>
          
          <div className="flex flex-col items-center gap-4">
            <Badge variant="outline" className="text-xs">
              Estimated Release: {estimatedRelease}
            </Badge>
            
            <Button variant="outline" size="sm">
              <Bell className="h-4 w-4 mr-2" />
              Get Notified
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};